import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import * as utils from './Utils';

function extractViewerModel() {
  let el = document.querySelector("#wix-viewer-model");
  if (!el) return;

  let innerText = el.innerText;
  let payload = {};
  try {
    payload = JSON.parse(innerText);
  } catch(e) {
    return;
  }

  return payload;
}

function isWixStore() {
  if (window.OnVoardData['is_wix_store']) return true;

  let payload = extractViewerModel();
  if (payload) {
    let payloadRoutes = get(payload, 'siteFeaturesConfigs.router.routes') || {};
    if (payloadRoutes['./checkout']) {
      window.OnVoardData['is_wix_store'] = true;
      return true;
    }
  }

  return false;
}

export function getCurrency() {
  const urlParams = new URLSearchParams(window.location.search);
  let currency = urlParams.get('currency');
  return currency;
}


export function initPageType(identifier='') {
  let pageId = wixEmbedsAPI.getCurrentPageInfo().id;

  if (identifier) {
    if (identifier === 'product_page') {
      window.OnVoardData['page_type'] = 'product';
      return;
    }

    if (identifier === 'shopping_cart') {
      window.OnVoardData['page_type'] = 'cart';
      return;
    }

    if (identifier === 'checkout') {
      window.OnVoardData['page_type'] = 'checkout';
      return;
    }
  }

  let currentUrl = location.protocol + '//' + location.host;
  if (location.pathname && location.pathname !== '/') currentUrl += location.pathname;

  if (wixEmbedsAPI.getExternalBaseUrl() === currentUrl) {
    window.OnVoardData['page_type'] = 'home';
    return;
  }

  let paths = location.pathname.split("/");
  if (document.querySelector("[data-hook='product-page']")) {
    window.OnVoardData['page_type'] = 'product';
    return;
  }

  if (document.querySelector(`#SITE_PAGES #${pageId} [data-hook='CartAppDataHook.root']`)) {
    window.OnVoardData['page_type'] = 'cart';
    return;
  }

  if (document.querySelector(`#SITE_PAGES #${pageId} [data-hook='ThankYouPageAppDataHook.root']`)) {
    window.OnVoardData['page_type'] = 'thank-you';
    return;
  }

  if (document.querySelector(`#SITE_PAGES #${pageId} [data-hook='product-list']`)) {
    window.OnVoardData['page_type'] = 'collection';
    return;
  }

  if (paths.length > 0 && paths.slice(-1)[0] === 'checkout') {
    window.OnVoardData['page_type'] = 'checkout';
    return;
  }
}

export function getCheckoutUrl() {
  let cart = window.OnVoardData.cart;
  if (!cart || !cart.cartId) return;

  let params = {
    "a11y": true,
    "cartId": cart.cartId,
    "storeUrl": wixEmbedsAPI.getExternalBaseUrl(),
    "isFastFlow": false,
    "isPickupFlow": false,
    "cashierPaymentId": "",
    "origin": "shopping cart",
    "originType": "addToCart"
  };

  let appSectionParams = encodeURIComponent(JSON.stringify(params));
  return `/checkout?appSectionParams=${appSectionParams}`;
}

export function updateCheckoutRoute() {
  let checkoutUrl = getCheckoutUrl();
  if (!checkoutUrl) return;
  if (!window.OnVoardData['routes']) return;
  window.OnVoardData['routes']['checkout'] = checkoutUrl;
}

export function initRoutes() {
  let routes = window.OnVoardData.routes || {};
  routes['cart'] = '/cart';

  let payload = extractViewerModel();
  if (payload) {
    let payloadRoutes = get(payload, 'siteFeaturesConfigs.router.routes') || {};

    // cartUrl
    let cartUrl = '';
    if (payloadRoutes['./cart']) cartUrl = '/cart';
    if (!cartUrl && payloadRoutes['./cart-page']) cartUrl = '/cart-page';
    if (!cartUrl && payloadRoutes['./shopping-cart']) cartUrl = '/shopping-cart';

    // find route with "cart"
    if (!cartUrl) {
      utils.loopObject(payloadRoutes, (key, value) => {
        if (cartUrl) return;
        if (key.includes("cart")) cartUrl = key.slice(1);
      })
    }

    if (cartUrl) routes['cart'] = cartUrl;
  }

  let checkoutUrl = getCheckoutUrl();
  if (checkoutUrl) routes['checkout'] = checkoutUrl;

  window.OnVoardData['routes'] = routes;
}

// only works for initial pageload
export function initProductData() {
  if (window.OnVoardData['page_type'] !== "product") return;
  let el = document.querySelector("#wix-warmup-data");
  if (!el) return;

  let innerText = el.innerText;
  let payload = {};
  try {
    payload = JSON.parse(innerText);
  } catch(e) {
    return;
  }

  if (!payload) return;
  let appsWarmupData = payload.appsWarmupData;
  if (!appsWarmupData) return;

  let storeData = appsWarmupData['1380b703-ce81-ff05-f115-39571d94dfcd'];
  if (!storeData) return;

  let productPage = null;
  Object.keys(storeData).forEach((key) => {
    if (key.startsWith("productPage")) {
      productPage = storeData[key];
    }
  });

  if (!productPage) return;
  window.OnVoardData['product'] = productPage['catalog']['product'];
}

export function getMemberApiParameters() {
  let dynamicModel = window.OnVoardData['dynamicModel'];
  let payload = extractViewerModel();
  if (!payload) return;

  let smToken = get(payload, 'siteFeaturesConfigs.siteMembers.smToken', '');
  if (!smToken) smToken = get(dynamicModel, 'smToken', '');

  let params = {};
  params['smToken'] = smToken;
  params['collectionId'] = get(payload, 'siteFeaturesConfigs.siteMembers.smcollectionId', '');
  params['metaSiteId'] = get(payload, 'site.metaSiteId', '');
  return params;
}

export function fetchMemberData(callback) {
  let params = getMemberApiParameters();

  if (!params) return;
  if (!params['smToken'] || !params['collectionId']) return;

  let smToken = params['smToken'];
  let collectionId = params['collectionId'];
  let metaSiteId = params['metaSiteId'];

  let path = `/_api/wix-sm-webapp/member/${smToken}?collectionId=${collectionId}&metaSiteId=${metaSiteId}`;
  fetch(wixEmbedsAPI.getExternalBaseUrl() + path, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(res => res.json())
  .then(json => {
    const memberData = json.payload;
    if (!memberData) return;
    window.OnVoardData['member'] = memberData;
    if (callback) callback();
  });
}

export function loadDynamicModel(callback) {
  fetch("/_api/v2/dynamicmodel", {
    method: 'GET'
  })
  .then(res => res.json())
  .then(json => {
    window.OnVoardData['dynamicModel'] = json;
    if (callback) callback();
  });
}

export function getCartAuthorization() {
  let dynamicModel = window.OnVoardData['dynamicModel'];
  if (!dynamicModel) {
    loadDynamicModel();
    return;
  }

  let authorization = get(dynamicModel, 'apps.1380b703-ce81-ff05-f115-39571d94dfcd.instance') || null;
  return authorization;
}

function waitUntilCartAuthorizationReady(callback) {
  let interval = 0;
  let authorization = null;
  let handle = window.setInterval(() => {
    if (interval > 1000*15) {
      clearInterval(handle);
      return;
    }

    authorization = getCartAuthorization();
    if (authorization) {
      clearInterval(handle);
      callback();
      return;
    }

    interval += 200;
  }, 200);
}

export function fetchProductData(params) {
  if (!isWixStore()) return;

  let callback = params['callback'];
  let currency = params['currency'];

  // get product slug
  let paths = decodeURI(window.location.pathname).split("/");
  let slug = paths.slice(-1)[0];
  if (!slug) return;

  let xsfrToken = utils.getCookie('XSRF-TOKEN');
  if (!xsfrToken) return;

  waitUntilCartAuthorizationReady(() => {
    let authorization = getCartAuthorization();
    if (!authorization) return;

    let path = wixEmbedsAPI.getExternalBaseUrl() + `/_api/wix-ecommerce-storefront-web/api?o=getProductBySlug&s=WixStoresWebClient&q=query,getProductBySlug($externalId:String!,$slug:String!,$withPriceRange:Boolean,=,false){appSettings(externalId:$externalId){widgetSettings}catalog{product(slug:$slug,onlyVisible:true){id,description,isVisible,sku,ribbon,brand,price,comparePrice,discountedPrice,formattedPrice,formattedComparePrice,formattedDiscountedPrice,pricePerUnit,formattedPricePerUnit,pricePerUnitData{baseQuantity,baseMeasurementUnit}seoTitle,seoDescription,createVersion,digitalProductFileItems{fileId,fileType,fileName}productItems(withDefaultVariant:true){id,price,comparePrice,formattedPrice,formattedComparePrice,pricePerUnit,formattedPricePerUnit,optionsSelections,isVisible,availableForPreOrder,inventory{status,quantity}sku,weight,surcharge,subscriptionPlans{list{id,price,formattedPrice,pricePerUnit,formattedPricePerUnit}}}name,isTrackingInventory,inventory{status,quantity,availableForPreOrder,preOrderInfoView{message,preOrder,limit}}isVisible,isManageProductItems,productItemsPreOrderAvailability,isInStock,media{id,url,fullUrl,altText,thumbnailFullUrl:fullUrl(width:50,height:50),mediaType,videoType,videoFiles{url,width,height,format,quality}width,height,index,title}customTextFields{key,title,isMandatory,inputLimit}nextOptionsSelectionId,options{id,title,optionType,key,selections{id,value,description,key,linkedMediaItems{altText,url,fullUrl,thumbnailFullUrl:fullUrl(width:50,height:50),mediaType,width,height,index,title,videoFiles{url,width,height,format,quality}}}}productType,urlPart,additionalInfo{id,title,description,index}subscriptionPlans{list(onlyVisible:true){id,name,tagline,frequency,interval,duration,price,formattedPrice,pricePerUnit,formattedPricePerUnit}oneTimePurchase{index}}priceRange(withSubscriptionPriceRange:true),@include(if:$withPriceRange){fromPriceFormatted}discount{mode,value}currency,weight,seoJson}}}&v=`;

    let v = {"slug":slug,"externalId":"","withPriceRange":false};
    path += encodeURIComponent(JSON.stringify(v));

    let headers = {};
    headers['Content-Type'] = 'application/json';
    headers['Authorization'] = authorization;
    headers['X-XSRF-TOKEN'] = xsfrToken;
    if (currency) headers['x-wix-currency'] = currency;

    fetch(path, {
      method: 'GET',
      headers: headers,
    })
    .then(res => res.json())
    .then(json => {
      const productData = get(json, 'data.catalog.product', {}) || {};
      window.OnVoardData['product'] = productData;
      callback();
    });
  });
}

export function fetchProductBySlug(params) {
  if (!isWixStore()) return;

  let slug = params['slug'];
  let callback = params['callback'];
  let currency = params['currency'];

  let xsfrToken = utils.getCookie('XSRF-TOKEN');
  if (!xsfrToken) return;

  waitUntilCartAuthorizationReady(() => {
    let authorization = getCartAuthorization();
    if (!authorization) return;

    let path = wixEmbedsAPI.getExternalBaseUrl() + `/_api/wix-ecommerce-storefront-web/api?o=getProductBySlug&s=WixStoresWebClient&q=query,getProductBySlug($externalId:String!,$slug:String!,$withPriceRange:Boolean,=,false){appSettings(externalId:$externalId){widgetSettings}catalog{product(slug:$slug,onlyVisible:true){id,description,isVisible,sku,ribbon,brand,price,comparePrice,discountedPrice,formattedPrice,formattedComparePrice,formattedDiscountedPrice,pricePerUnit,formattedPricePerUnit,pricePerUnitData{baseQuantity,baseMeasurementUnit}seoTitle,seoDescription,createVersion,digitalProductFileItems{fileId,fileType,fileName}productItems(withDefaultVariant:true){id,price,comparePrice,formattedPrice,formattedComparePrice,pricePerUnit,formattedPricePerUnit,optionsSelections,isVisible,inventory{status,quantity}sku,weight,surcharge,subscriptionPlans{list{id,price,formattedPrice,pricePerUnit,formattedPricePerUnit}}}name,isTrackingInventory,inventory{status,quantity}isVisible,isManageProductItems,isInStock,media{id,url,fullUrl,altText,thumbnailFullUrl:fullUrl(width:50,height:50),mediaType,videoType,videoFiles{url,width,height,format,quality}width,height,index,title}customTextFields{key,title,isMandatory,inputLimit}nextOptionsSelectionId,options{id,title,optionType,key,selections{id,value,description,key,linkedMediaItems{altText,url,fullUrl,thumbnailFullUrl:fullUrl(width:50,height:50),mediaType,width,height,index,title,videoFiles{url,width,height,format,quality}}}}productType,urlPart,additionalInfo{id,title,description,index}subscriptionPlans{list(onlyVisible:true){id,name,tagline,frequency,duration,price,formattedPrice,pricePerUnit,formattedPricePerUnit}oneTimePurchase{index}}priceRange(withSubscriptionPriceRange:true),@include(if:$withPriceRange){fromPriceFormatted}discount{mode,value}currency,weight,seoJson}}}&v=`;

    let v = {"slug":slug,"externalId":"","withPriceRange":false};
    path += encodeURIComponent(JSON.stringify(v));

    let headers = {};
    headers['Content-Type'] = 'application/json';
    headers['Authorization'] = authorization;
    headers['X-XSRF-TOKEN'] = xsfrToken;
    if (currency) headers['x-wix-currency'] = currency;

    fetch(path, {
      method: 'GET',
      headers: headers,
    })
    .then(res => res.json())
    .then(json => {
      const productData = get(json, 'data.catalog.product', {}) || {};
      callback(productData);
    });
  });
}


export function fetchProductById(params) {
  if (!isWixStore()) return;

  let productId = params['productId'];
  let callback = params['callback'];
  let currency = params['currency'];

  let xsfrToken = utils.getCookie('XSRF-TOKEN');
  if (!xsfrToken) return;

  waitUntilCartAuthorizationReady(() => {
    let authorization = getCartAuthorization();
    if (!authorization) return;

    let query = `query getData(
        $externalId: String!
        $productId: String!
      ) {
        appSettings(externalId: $externalId) {
          widgetSettings
        }
        catalog {
          product(productId: $productId) {
            id
            description
            isVisible
            sku
            ribbon
            brand
            price
            comparePrice
            discountedPrice
            formattedPrice
            formattedComparePrice
            formattedDiscountedPrice
            pricePerUnit
            formattedPricePerUnit
            digitalProductFileItems {
              fileId
              fileType
              fileName
            }
            productItems(withDefaultVariant: true) {
              id
              price
              comparePrice
              formattedPrice
              formattedComparePrice
              pricePerUnit
              formattedPricePerUnit
              optionsSelections
              isVisible
              inventory {
                status
                quantity
              }
              sku
              weight
              surcharge
            }
            name
            isTrackingInventory
            inventory {
              status
              quantity
            }
            isVisible
            isManageProductItems
            isInStock
            media {
              id
              url
              fullUrl
              altText
              thumbnailFullUrl: fullUrl(width: 50, height: 50)
              width
              height
              index
              title
            }
            options {
              id
              title
              optionType
              key
            }
            productType
            urlPart
          }
        }
      }
    `;

    let headers = {};
    headers['Content-Type'] = 'application/json';
    headers['Authorization'] = authorization;
    headers['X-XSRF-TOKEN'] = xsfrToken;
    if (currency) headers['x-wix-currency'] = currency;

    fetch(wixEmbedsAPI.getExternalBaseUrl() + '/_api/wix-ecommerce-graphql-web/api', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        operationName: "getData",
        query: query,
        source: "WixStoresWebClient",
        variables: {"externalId":"","productId": productId},
      }),
    })
    .then(res => res.json())
    .then(json => {
      const productData = get(json, 'data.catalog.product', {}) || {};
      callback(productData);
    });
  });
}

export function fetchCartData(params) {
  if (!isWixStore()) return;

  let callback = params['callback'];
  let currency = params['currency'];

  let xsfrToken = utils.getCookie('XSRF-TOKEN');
  if (!xsfrToken) return;

  waitUntilCartAuthorizationReady(() => {
    let authorization = getCartAuthorization();
    if (!authorization) return;

    let query = `
      query getCart($locale: String!, $withTax: Boolean, $withShipping: Boolean) {
        cart {
          cartId
          storeId
          buyerNote
          items {
            cartItemId
            product {
              id
              productType
              urlPart
              weight
              name
              price
              comparePrice
              customTextFields {
                title
                value
              }
              media(limit: 1) {
                altText
                mediaType
                url
                height
                width
              }
              digitalProductFileItems {
                fileType
              }
            }
            optionsSelectionsValues {
              id
              title
              value
            }
            freeText {
              title
              value
            }
            sku
            quantity
            inventoryQuantity
            convertedPrices {
              formattedComparePrice
              formattedPrice
              formattedTotalPrice
              totalPrice
              formattedPriceBeforeDiscount
              price
            }
            formattedPriceBeforeDiscount
            discountRules {
              name
            }
          }
          appliedCoupon {
            discountValue
            convertedDiscountValue
            code
            couponId
            couponType
            name
          }
          currencyFormat {
            code
          }
          convertedCurrencyFormat {
            code
          }
          additionalFees {
            code
            name
            totalPrice
            formattedTotalPrice
            convertedFormattedTotalPrice
          }
          totals(withTax: $withTax, withShipping: $withShipping) {
            subTotal
            total
            shipping
            discount
            itemsTotal
            tax
            additionalFeesTotal
            formattedItemsTotal
            formattedSubTotal
            formattedShipping
            formattedDiscount
            formattedTax
            formattedAdditionalFeesTotal
            formattedTotal
          }
          convertedTotals(withTax: $withTax, withShipping: $withShipping) {
            subTotal
            total
            shipping
            discount
            itemsTotal
            tax
            additionalFeesTotal
            formattedItemsTotal
            formattedSubTotal
            formattedShipping
            formattedDiscount
            formattedTax
            formattedAdditionalFeesTotal
            formattedTotal
          }
          destination {
            country
            countryName(translateTo: $locale)
            subdivision
            subdivisionName(translateTo: $locale)
            zipCode
          }
          selectedShippingOption {
            id
          }
          shippingRuleInfo {
            status
            canShipToDestination
            shippingRule {
              id
              options {
                id
                title
                rate: convertedRate
                formattedRate: convertedFormattedRate
                deliveryTime
                pickupInfo {
                  address {
                    countryName(translateTo: $locale)
                    subdivisionName(translateTo: $locale)
                    addressLine
                    city
                  }
                  pickupMethod
                }
              }
            }
          }
          destinationCompleteness
          minimumOrderAmount {
            reached
            diff
            value
            convertedDiff
            convertedValue
            formattedConvertedDiff
            formattedConvertedValue
          }
        }
      }
    `;

    let headers = {};
    headers['Content-Type'] = 'application/json';
    headers['Authorization'] = authorization;
    headers['X-XSRF-TOKEN'] = xsfrToken;
    if (currency) headers['x-wix-currency'] = currency;

    fetch(wixEmbedsAPI.getExternalBaseUrl() + '/_api/wixstores-graphql-server/graphql', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        operationName: "getCart",
        query: query,
        source: "Init",
        variables: {locale: "en", withShipping: false, withTax: false},
      }),
    })
    .then(res => res.json())
    .then(json => {
      const cartData = get(json, 'data.cart', {}) || {};
      window.OnVoardData['cart'] = cartData;
      updateCheckoutRoute();
      callback(cartData);
    });
  });
}

export function addCartItem(param, successCallback, errorCallback) {
  if (!isWixStore()) return;

  let xsfrToken = utils.getCookie('XSRF-TOKEN');
  if (!xsfrToken) return;

  waitUntilCartAuthorizationReady(() => {
    let authorization = getCartAuthorization();
    if (!authorization) return;

    let query = `mutation addToCart($params: [AddToCartInput!]) {
      cart {
        addToCart(params: $params) {

      errors {
        code
        commandName
        message
        field
      }
      cart {
        cartId
        storeId
        buyerNote
        items {
          cartItemId
          convertedFormattedComparePrice
          convertedFormattedPrice
          convertedFormattedTotalPrice
          convertedPrices {
            comparePrice
            formattedComparePrice
            formattedPrice
            formattedTotalPrice
            price
            totalPrice
          }
          product {
            comparePrice
            convertedComparePrice
            convertedPrice
            customTextFields {
              title
              value
            }
            id
            productType
            urlPart
            name
            pageUrl
            price
            sku
            weight
            media(limit: 1) {
              altText
              mediaType
              url
              height
              width
            }
            digitalProductFileItems {
              fileType
            }
          }
          optionsSelectionsValues {
            id
            title
            value
          }
          convertedTotalPrice
          sku
          quantity
          inventoryQuantity
          formattedComparePrice
          formattedPrice
          formattedTotalPrice
          totalPrice
        }
      }
        }
      }
    }`;

    fetch(wixEmbedsAPI.getExternalBaseUrl() + '/_api/wixstores-graphql-server/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authorization,
        'X-XSRF-TOKEN': xsfrToken
      },
      body: JSON.stringify({
        operationName: "addToCart",
        query: query,
        source: "WixStoresWebClient",
        variables: {
          "params": [param]
        },
      }),
    })
    .then(res => res.json())
    .then(json => {
      successCallback(json);
    })
    .catch((error) => {
      errorCallback(error);
    });
  });
}

function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

function decodeAppScripts(input) {
  let output = null;

  try {
    output = JSON.parse(htmlDecode(input));
  } catch (error) {
    console.error(error);
  }

  return output;
}

function shouldReplaceAppScripts(curAppScripts, newAppScripts) {
  if (!curAppScripts || !curAppScripts.ts) return true;
  if (curAppScripts.ts && newAppScripts.ts) {
    if (newAppScripts.ts > curAppScripts.ts) return true;
  }

  return false;
}

function mergeAppScripts(curAppScripts, newAppScripts) {
  utils.loopObject(newAppScripts, (key, value) => {
    if (key in curAppScripts) return;
    curAppScripts[key] = value;
  })

  return curAppScripts;
}

function getAppScripts() {
  let appScripts = {};

  if (window.OnVoardData["app_scripts"]) {
    appScripts = decodeAppScripts(window.OnVoardData["app_scripts"]);
  }

  if (window.OV_MARKETING_PLATFORM_APP_SCRIPTS) {
    let mpScripts = decodeAppScripts(window.OV_MARKETING_PLATFORM_APP_SCRIPTS);
    appScripts = mergeAppScripts(appScripts, mpScripts);
  }

  if (window.OV_AOV_PROGRESS_BAR_APP_SCRIPTS) {
    let aovProgressBarScripts = decodeAppScripts(window.OV_AOV_PROGRESS_BAR_APP_SCRIPTS);
    appScripts = mergeAppScripts(appScripts, aovProgressBarScripts);
  }

  if (window.OV_BACK_IN_STOCK_APP_SCRIPTS) {
    let backInStockScripts = decodeAppScripts(window.OV_BACK_IN_STOCK_APP_SCRIPTS);
    appScripts = mergeAppScripts(appScripts, backInStockScripts);
  }

  if (window.OV_REVIEWS_APP_SCRIPTS) {
    let reviewsScripts = decodeAppScripts(window.OV_REVIEWS_APP_SCRIPTS);
    appScripts = mergeAppScripts(appScripts, reviewsScripts);
  }

  if (window.OV_PROMPT_APP_SCRIPTS) {
    let promptScripts = decodeAppScripts(window.OV_PROMPT_APP_SCRIPTS);
    appScripts = mergeAppScripts(appScripts, promptScripts);
  }

  if (window.OV_RECOMMENDER_APP_SCRIPTS) {
    let recommenderScripts = decodeAppScripts(window.OV_RECOMMENDER_APP_SCRIPTS);
    appScripts = mergeAppScripts(appScripts, recommenderScripts);
  }

  if (window.OV_REPERKS_APP_SCRIPTS) {
    let reperksScripts = decodeAppScripts(window.OV_REPERKS_APP_SCRIPTS);
    appScripts = mergeAppScripts(appScripts, reperksScripts);
  }

  return appScripts;
}

export function provisionAppScripts() {
  let appScripts = getAppScripts();
  if (!appScripts) return;
  let pageId = wixEmbedsAPI.getCurrentPageInfo().id;

  // webtracking
  let wt = appScripts.web_tracking;
  if (wt && wt.token) {
    let ovWtDiv = document.querySelector('.ov-app-web-tracking');
    if (!ovWtDiv) {
      ovWtDiv = document.createElement("div");
      ovWtDiv.setAttribute("class", "ov-app ov-app-web-tracking");
      ovWtDiv.setAttribute("data-app", "web-tracking");
      ovWtDiv.setAttribute("data-token", wt.token);
      document.body.appendChild(ovWtDiv);
    }

    if (wt.auto_track) {
      ovWtDiv = document.querySelector('.ov-app-web-tracking-wix');
      if (!ovWtDiv) {
        ovWtDiv = document.createElement("div");
        ovWtDiv.setAttribute("class", "ov-app ov-app-web-tracking-wix");
        ovWtDiv.setAttribute("data-app", "web-tracking-wix");
        document.body.appendChild(ovWtDiv);
      }

      OnVoard("web_tracking_wix", "identify", window.OnVoardData);

      if (wt.track_checkout_started) {
        OnVoard("web_tracking_wix", "trackCheckoutStarted", window.OnVoardData);
      }

      if (wt.track_product_viewed) {
        OnVoard("web_tracking_wix", "trackProductViewed", window.OnVoardData);
      }

      if (wt.track_cart_item_added) {
        OnVoard("web_tracking_wix", "trackCartItemAdded", window.OnVoardData);
      }
    }
  }

  // prompt
  let prompt = appScripts.prompt;
  if (prompt && prompt.footer) {
    let promptEl = document.querySelector('.ov-app-prompt');
    if (!promptEl) {
      promptEl = document.createElement("div");
      promptEl.setAttribute("class", "ov-app ov-app-prompt");
      promptEl.setAttribute("data-app", "prompt");
      promptEl.setAttribute("data-account-id", prompt.footer.account_id);
      document.body.appendChild(promptEl);
    }
  }

  // reperks widget
  let reperksWidget = appScripts.reperks_widget;
  if (reperksWidget && reperksWidget.global) {
    let reperksWidgetEl = document.querySelector('.ov-app-reperks-widget');
    if (!reperksWidgetEl) {
      reperksWidgetEl = document.createElement("div");
      reperksWidgetEl.setAttribute("class", "ov-app ov-app-reperks-widget");
      reperksWidgetEl.setAttribute("data-app", "reperks-widget");
      reperksWidgetEl.setAttribute("data-app-id", reperksWidget.global.id);
      document.body.appendChild(reperksWidgetEl);
    }
  }

  // aov progress bar
  let aov = appScripts.aov_progress_bar;
  let aovEl = null;

  if (aov) {
    aov.product_button.forEach((row) => {
      aovEl = document.querySelector(`ov-app-aov-progress-bar[data-app-id="${row.id}"]`);
      if (aovEl) return;
      if (window.OnVoardData['page_type'] !== 'product') return;

      let btnEl = document.querySelector("[data-hook='product-page'] [data-hook='buy-now-button']");
      if (!btnEl) {
        btnEl = document.querySelector("[data-hook='product-page'] [data-hook='add-to-cart']");
      }

      if (!btnEl) return;
      let referenceNode = btnEl.parentElement;

      aovEl = document.createElement("div");
      aovEl.setAttribute("class", "ov-app ov-app-aov-progress-bar");
      aovEl.setAttribute("data-app", "aov-progress-bar");
      aovEl.setAttribute("data-app-id", row.id);
      aovEl.setAttribute("data-placement-mode", row.placement);
      referenceNode.parentNode.insertBefore(aovEl, referenceNode.nextSibling);
    })

    aov.product_bottom.forEach((row) => {
      aovEl = document.querySelector(`ov-app-aov-progress-bar[data-app-id="${row.id}"]`);
      if (aovEl) return;
      if (window.OnVoardData['page_type'] !== 'product') return;

      aovEl = document.createElement("div");
      aovEl.setAttribute("class", "ov-app ov-app-aov-progress-bar");
      aovEl.setAttribute("data-app", "aov-progress-bar");
      aovEl.setAttribute("data-app-id", row.id);
      aovEl.setAttribute("data-placement-mode", row.placement);
      document.body.appendChild(aovEl);
    })
  }

  // reviews widget
  let rw = appScripts.reviews_widget;
  let rwEl = null;

  if (rw) {
    rw.product_bottom.forEach((row) => {
      rwEl = document.querySelector(`ov-app-reviews-widget[data-app-id="${row.id}"]`);
      if (rwEl) return;
      if (window.OnVoardData['page_type'] !== 'product') return;

      let productEl = document.querySelector("[data-hook='product-page']");
      if (!productEl) return;

      rwEl = document.createElement("div");
      rwEl.setAttribute("class", "ov-app ov-app-reviews-widget");
      rwEl.setAttribute("data-app", "reviews-widget");
      rwEl.setAttribute("data-app-id", row.id);
      rwEl.setAttribute("data-product-external-id", window.OnVoardData.product.id);
      rwEl.setAttribute("data-placement-mode", row.placement);
      productEl.appendChild(rwEl);
    })
  }


  // star rating
  let sr = appScripts.star_rating;
  let srEl = null;

  if (sr) {
    sr.product_title.forEach((row) => {
      srEl = document.querySelector(`ov-app-star-rating[data-app-id="${row.id}"]`);
      if (srEl) return;
      if (window.OnVoardData['page_type'] !== 'product') return;

      let titleEl = document.querySelector("[data-hook='product-page'] [data-hook='product-title']");
      if (!titleEl) return;
      let referenceNode = titleEl.parentElement;

      srEl = document.createElement("div");
      srEl.setAttribute("class", "ov-app ov-app-star-rating");
      srEl.setAttribute("data-app", "star-rating");
      srEl.setAttribute("data-app-id", row.id);
      srEl.setAttribute("data-product-external-id", window.OnVoardData.product.id);
      srEl.setAttribute("data-placement-mode", row.placement);
      referenceNode.parentNode.insertBefore(srEl, referenceNode.nextSibling);
    })

    sr.product_bottom.forEach((row) => {
      srEl = document.querySelector(`ov-app-star-rating[data-app-id="${row.id}"]`);
      if (srEl) return;
      if (window.OnVoardData['page_type'] !== 'product') return;

      srEl = document.createElement("div");
      srEl.setAttribute("class", "ov-app ov-app-star-rating");
      srEl.setAttribute("data-app", "star-rating");
      srEl.setAttribute("data-app-id", row.id);
      srEl.setAttribute("data-product-external-id", window.OnVoardData.product.id);
      srEl.setAttribute("data-placement-mode", row.placement);
      document.body.appendChild(srEl);
    })

    let attachStarRatingToProduct = (productsMapper, row) => {
      if (!productsMapper) return;

      let nodeList = document.querySelectorAll(`#SITE_PAGES #${pageId} [data-hook='product-list'] [data-hook='product-list-grid-item']`);
      nodeList.forEach((el) => {
        const ahrefEl = el.querySelector(`a[data-hook='product-item-container']`);
        if (!ahrefEl) return;

        let href = ahrefEl.getAttribute('href');
        let paths = href.split("/");
        let slug = paths.slice(-1)[0];
        if (!slug) return;

        let product = productsMapper[slug];
        if (!product) return;

        const titleEl = el.querySelector(`[data-hook='product-item-name']`);
        if (!titleEl) return;

        // exclude duplicates
        srEl = el.querySelector(`.ov-app-star-rating`);
        if (srEl) return;

        srEl = document.createElement("div");
        srEl.setAttribute("class", "ov-app ov-app-star-rating");
        srEl.setAttribute("data-app", "star-rating");
        srEl.setAttribute("data-app-id", row.id);
        srEl.setAttribute("data-product-external-id", product.id);
        srEl.setAttribute("data-placement-mode", row.placement);
        titleEl.parentNode.insertBefore(srEl, titleEl.nextSibling);
      })
    };

    if (sr.collection_product) {
      sr.collection_product.forEach((row) => {
        attachStarRatingToProduct(window.OnVoardData['collection_products'], row);
      });
    }

    if (sr.home_product) {
      sr.home_product.forEach((row) => {
        attachStarRatingToProduct(window.OnVoardData['home_products'], row);
      });
    }
  }

  // back-in-stock
  let bis = appScripts.back_in_stock;
  let bisEl = null;

  if (bis) {
    let bisFloatingBtn = bis.floating_button;
    let bisInlineBtn = bis.inline_button;
    let bisInlineText = bis.inline_text;
    let bisInlineForm = bis.inline_form;

    if (bis.global) {
      bisEl = document.querySelector('.ov-app-back-in-stock');
      if (!bisEl) {
        bisEl = document.createElement("div");
        bisEl.setAttribute("class", "ov-app ov-app-back-in-stock");
        bisEl.setAttribute("data-app", "back-in-stock");
        bisEl.setAttribute("data-app-id", bis.global.id);
        document.body.appendChild(bisEl);
      }
    }

    if (bisFloatingBtn && bisFloatingBtn.product_bottom) {
      bisEl = document.querySelector('.ov-app-back-in-stock-floating-button');
      if (!bisEl) {
        bisEl = document.createElement("div");
        bisEl.setAttribute("class", "ov-app ov-app-back-in-stock-floating-button");
        bisEl.setAttribute("data-app", "back-in-stock-floating-button");
        bisEl.setAttribute("data-app-id", bisFloatingBtn.product_bottom.id);
        bisEl.setAttribute("data-placement-mode", bisFloatingBtn.product_bottom.placement);
        document.body.appendChild(bisEl);
      }
    }

    if (bisInlineBtn) {
      if (bisInlineBtn.product_button) {
        bisEl = document.querySelector('.ov-app-back-in-stock-inline-button');
        if (!bisEl) {
          let referenceNode = null;
          let btnEl = document.querySelector("[data-hook='product-page'] [data-hook='buy-now-button']");
          if (!btnEl) btnEl = document.querySelector("[data-hook='product-page'] [data-hook='add-to-cart']");
          if (btnEl) referenceNode = btnEl.parentElement;

          if (!referenceNode) referenceNode = document.querySelector("[data-hook='product-page'] [data-hook='product-options']");
          if (referenceNode) {
            bisEl = document.createElement("div");
            bisEl.setAttribute("class", "ov-app ov-app-back-in-stock-inline-button");
            bisEl.setAttribute("data-app", "back-in-stock-inline-button");
            bisEl.setAttribute("data-app-id", bisInlineBtn.product_button.id);
            bisEl.setAttribute("data-placement-mode", bisInlineBtn.product_button.placement);
            referenceNode.parentNode.insertBefore(bisEl, referenceNode.nextSibling);
          }
        }
      }

      if (bisInlineBtn.product_bottom) {
        bisEl = document.querySelector('.ov-app-back-in-stock-inline-button');
        if (!bisEl) {
          bisEl = document.createElement("div");
          bisEl.setAttribute("class", "ov-app ov-app-back-in-stock-inline-button");
          bisEl.setAttribute("data-app", "back-in-stock-inline-button");
          bisEl.setAttribute("data-app-id", bisInlineBtn.product_bottom.id);
          bisEl.setAttribute("data-placement-mode", bisInlineBtn.product_bottom.placement);
          document.body.appendChild(bisEl);
        }
      }
    }

    if (bisInlineText) {
      if (bisInlineText.product_button) {
        bisEl = document.querySelector('.ov-app-back-in-stock-inline-text');
        if (!bisEl) {
          let referenceNode = null;
          let btnEl = document.querySelector("[data-hook='product-page'] [data-hook='buy-now-button']");
          if (!btnEl) btnEl = document.querySelector("[data-hook='product-page'] [data-hook='add-to-cart']");
          if (btnEl) referenceNode = btnEl.parentElement;

          if (!referenceNode) referenceNode = document.querySelector("[data-hook='product-page'] [data-hook='product-options']");
          if (referenceNode) {
            bisEl = document.createElement("div");
            bisEl.setAttribute("class", "ov-app ov-app-back-in-stock-inline-text");
            bisEl.setAttribute("data-app", "back-in-stock-inline-text");
            bisEl.setAttribute("data-app-id", bisInlineText.product_button.id);
            bisEl.setAttribute("data-placement-mode", bisInlineText.product_button.placement);
            referenceNode.parentNode.insertBefore(bisEl, referenceNode.nextSibling);
          }
        }
      }

      if (bisInlineText.product_bottom) {
        bisEl = document.querySelector('.ov-app-back-in-stock-inline-text');
        if (!bisEl) {
          bisEl = document.createElement("div");
          bisEl.setAttribute("class", "ov-app ov-app-back-in-stock-inline-text");
          bisEl.setAttribute("data-app", "back-in-stock-inline-text");
          bisEl.setAttribute("data-app-id", bisInlineText.product_bottom.id);
          bisEl.setAttribute("data-placement-mode", bisInlineText.product_bottom.placement);
          document.body.appendChild(bisEl);
        }
      }
    }

    if (bisInlineForm) {
      if (bisInlineForm.product_button) {
        bisEl = document.querySelector('.ov-app-back-in-stock-inline-form');
        if (!bisEl) {
          let referenceNode = null;
          let btnEl = document.querySelector("[data-hook='product-page'] [data-hook='buy-now-button']");
          if (!btnEl) btnEl = document.querySelector("[data-hook='product-page'] [data-hook='add-to-cart']");
          if (btnEl) referenceNode = btnEl.parentElement;

          if (!referenceNode) referenceNode = document.querySelector("[data-hook='product-page'] [data-hook='product-options']");
          if (referenceNode) {
            bisEl = document.createElement("div");
            bisEl.setAttribute("class", "ov-app ov-app-back-in-stock-inline-form");
            bisEl.setAttribute("data-app", "back-in-stock-inline-form");
            bisEl.setAttribute("data-app-id", bisInlineForm.product_button.id);
            bisEl.setAttribute("data-placement-mode", bisInlineForm.product_button.placement);
            referenceNode.parentNode.insertBefore(bisEl, referenceNode.nextSibling);
          }
        }
      }

      if (bisInlineForm.product_bottom) {
        bisEl = document.querySelector('.ov-app-back-in-stock-inline-form');
        if (!bisEl) {
          bisEl = document.createElement("div");
          bisEl.setAttribute("class", "ov-app ov-app-back-in-stock-inline-form");
          bisEl.setAttribute("data-app", "back-in-stock-inline-form");
          bisEl.setAttribute("data-app-id", bisInlineForm.product_bottom.id);
          bisEl.setAttribute("data-placement-mode", bisInlineForm.product_bottom.placement);
          document.body.appendChild(bisEl);
        }
      }
    }

  }

  // recommender
  let recommender = appScripts.recommender;
  let recommenderEl = null;

  if (recommender) {
    if (recommender.tracking) {
      recommenderEl = document.querySelector('.ov-app-recommender-tracking');
      if (!recommenderEl) {
        recommenderEl = document.createElement("div");
        recommenderEl.setAttribute("class", "ov-app ov-app-recommender-tracking");
        recommenderEl.setAttribute("data-app", "recommender-tracking");
        recommenderEl.setAttribute("data-account-id", recommender.tracking.account_id);
        document.body.appendChild(recommenderEl);
      }
    }

    recommender.home_bottom.forEach((row) => {
      recommenderEl = document.querySelector(`ov-app-recommender[data-app-id="${row.id}"]`);
      if (recommenderEl) return;
      if (window.OnVoardData['page_type'] !== 'home') return;

      let pageEl = document.querySelector("#SITE_PAGES");
      if (!pageEl) return;

      recommenderEl = document.createElement("div");
      recommenderEl.setAttribute("class", "ov-app ov-app-recommender");
      recommenderEl.setAttribute("data-app", "recommender");
      recommenderEl.setAttribute("data-app-id", row.id);
      recommenderEl.setAttribute("data-placement-mode", row.placement);
      pageEl.appendChild(recommenderEl);
    })

    recommender.cart_bottom.forEach((row) => {
      recommenderEl = document.querySelector(`ov-app-recommender[data-app-id="${row.id}"]`);
      if (recommenderEl) return;
      if (window.OnVoardData['page_type'] !== 'cart') return;

      let cartEl = document.querySelector("[data-hook='CartAppDataHook.root']");
      if (!cartEl) return;

      recommenderEl = document.createElement("div");
      recommenderEl.setAttribute("class", "ov-app ov-app-recommender");
      recommenderEl.setAttribute("data-app", "recommender");
      recommenderEl.setAttribute("data-app-id", row.id);
      recommenderEl.setAttribute("data-placement-mode", row.placement);
      document.body.appendChild(recommenderEl);
      cartEl.appendChild(recommenderEl);
    })

    recommender.collection_bottom.forEach((row) => {
      recommenderEl = document.querySelector(`ov-app-recommender[data-app-id="${row.id}"]`);
      if (recommenderEl) return;
      if (window.OnVoardData['page_type'] !== 'collection') return;

      let pageEl = document.querySelector("#SITE_PAGES");
      if (!pageEl) return;

      recommenderEl = document.createElement("div");
      recommenderEl.setAttribute("class", "ov-app ov-app-recommender");
      recommenderEl.setAttribute("data-app", "recommender");
      recommenderEl.setAttribute("data-app-id", row.id);
      recommenderEl.setAttribute("data-placement-mode", row.placement);
      pageEl.appendChild(recommenderEl);
    })

    recommender.product_bottom.forEach((row) => {
      recommenderEl = document.querySelector(`ov-app-recommender[data-app-id="${row.id}"]`);
      if (recommenderEl) return;
      if (window.OnVoardData['page_type'] !== 'product') return;

      let productEl = document.querySelector("[data-hook='product-page']");
      if (!productEl) return;

      recommenderEl = document.createElement("div");
      recommenderEl.setAttribute("class", "ov-app ov-app-recommender");
      recommenderEl.setAttribute("data-app", "recommender");
      recommenderEl.setAttribute("data-app-id", row.id);
      recommenderEl.setAttribute("data-placement-mode", row.placement);
      productEl.appendChild(recommenderEl);
    })
  }
}

export function fetchProductsForGrid(params) {
  let callback = params['callback'];
  let pageId = wixEmbedsAPI.getCurrentPageInfo().id;
  let nodeList = document.querySelectorAll(`#SITE_PAGES #${pageId} [data-hook='product-list'] [data-hook='product-list-grid-item']`);
  let mapper = {};
  let numRequests = 0;
  let pageType = window.OnVoardData['page_type'];

  nodeList.forEach((el) => {
    const ahrefEl = el.querySelector(`a[data-hook='product-item-container']`);
    if (!ahrefEl) return;

    let href = ahrefEl.getAttribute('href');
    let paths = href.split("/");
    let slug = paths.slice(-1)[0];
    if (!slug) return;

    let fetchCallback = (productData) => {
      mapper[slug] = productData;
    };

    fetchProductBySlug({
      slug: slug,
      callback: fetchCallback,
    });

    numRequests += 1;
  })

  // wait until requests complete
  let interval = 0;
  let handle = window.setInterval(() => {
    if (interval > 1000*10) {
      clearInterval(handle);
      return;
    }

    if (Object.keys(mapper).length >= numRequests) {
      clearInterval(handle);

      if (pageType === 'collection') window.OnVoardData['collection_products'] = mapper;
      if (pageType === 'home') window.OnVoardData['home_products'] = mapper;
      callback()
      return;
    }

    interval += 100;
  }, 100);
}

function shouldLoadProducts() {
  if (window.OnVoardData['load_collection_products']) return true;

  let appScripts = getAppScripts();
  if (appScripts) {
    let sr = appScripts.star_rating;
    if (sr && sr.collection_product && sr.collection_product.length > 0) return true;
    if (sr && sr.home_product && sr.home_product.length > 0) return true;
  }

  return false;
}

export function onVariantChange(showWidgetsCallback) {
  let product = window.OnVoardData['product'];
  if (!product.isManageProductItems) return;

  let selectedChoices = window.OnVoardData['selected_product_choices'];
  if (!selectedChoices) return;

  let optionsSelections = [];
  product.options.forEach((option) => {
    option.selections.forEach((selection) => {
      selection['optionKey'] = option.key;
      optionsSelections.push(selection);
    })
  })

  product.productItems.forEach((item) => {
    let itemChoices = {}
    item.optionsSelections.forEach((selectionId, idx) => {
      let selection = optionsSelections.filter((row) => row.id === selectionId)[0];
      if (!selection) return;
      itemChoices[selection.optionKey] = selection.key;
    })

    if (!isEqual(selectedChoices, itemChoices)) return;
    if (0 >= item.inventory.quantity) {
      showWidgetsCallback(item);
    }
  })
}


export function refreshBuiltInBackInStock() {
  // hide wix default back-in-stock
  let el = document.querySelector("[data-hook='product-page'] [data-hook='BackInStockButton.Root']");
  if (el) {
    el.style.display = 'none';

    let cellEl = el.closest('.cell');
    if (cellEl) {
      cellEl.style.display = 'none';
    }

    return;
  }

  // has add cart
  el = document.querySelector("[data-hook='product-page'] [data-hook='add-to-cart']");
  if (el) {
    let cellEl = el.closest('.cell');
    if (cellEl) {
      cellEl.style.display = 'flex';
    }
  }
}


function pageReset() {
  // remove OnVoard elements
  document.querySelectorAll(".ov-app").forEach((el) => el.remove());
  document.querySelectorAll(".ov-modals").forEach((el) => el.remove());

  window.OnVoardData['page_type'] = null;
  window.OnVoardData['product'] = null;
  window.OnVoardData['collection_products'] = null;
  window.OnVoardData['home_products'] = null;
  window.OnVoardData['selected_product_choices'] = null;
}

function cartReload() {
  if (!isWixStore()) return;

  import('common/cart-utils')
  .then((cartUtils) => {
    cartUtils.setupCartUpdateEvent();
    cartUtils.loadCart();
  });
}


export function registerWixListener(loadScriptsCallback) {
  let refreshCallback = () => {
    provisionAppScripts();
    loadScriptsCallback();
  };

  let handlePageView = (data) => {
    let pageTypeIdentifier = data.pageTypeIdentifier;
    initPageType(pageTypeIdentifier);

    let pageType = window.OnVoardData['page_type'];
    if (pageType === 'product') {
      fetchProductData({callback: refreshCallback});
      return;
    }

    if (shouldLoadProducts()) {
      fetchProductsForGrid({callback: refreshCallback});
      return;
    }

    if (["cart", "checkout"].includes(pageType)) {
      cartReload();
    }

    // load if cart is missing
    if (!window.OnVoardData['cart']) {
      cartReload();
    }

    refreshCallback();
  };


  let registerListener = () => {
    window.wixDevelopersAnalytics.register('552d8274-b6ec-4a52-abd2-ba974b5ed307', (eventName, data) => {
      if (["PageView", "productPageLoaded"].includes(eventName)) {

        // `PageView` event won't be fired when hyperlinking from product A to product B (used in Recommender)
        // Hence, we are using `productPageLoaded` event to detect loading of product page
        if (eventName === "PageView" && data.pageTypeIdentifier === "product_page") return;
        if (eventName === "productPageLoaded") data.pageTypeIdentifier = "product_page";

        pageReset();
        handlePageView(data);
      }

      if (["AddProductImpression"].includes(eventName)) {
        let pageType = window.OnVoardData['page_type'];

        if (shouldLoadProducts()) {
          fetchProductsForGrid({callback: refreshCallback});
          return;
        }
      }

      if (["AddToCart", "RemoveFromCart"].includes(eventName)) {
        setTimeout(() => {
          cartReload();
        }, 500);
      }

      if (eventName === 'Purchase') {
        window.OnVoardData['purchase'] = data;
      }

      if (eventName === 'CustomEvent') {
        if (data.eventAction === 'Log in Success') {
          loadDynamicModel(() => {
            fetchMemberData(() => {
              document.dispatchEvent(new CustomEvent("ov_wix_login_success", {detail: data}));
            });
          })
        }

        if (data.eventAction === 'Sign up Success') {
          loadDynamicModel(() => {
            fetchMemberData(() => {
              document.dispatchEvent(new CustomEvent("ov_wix_signup_success", {detail: data}));
            });
          })
        }
      }
    })
  };

  window.wixDevelopersAnalytics ? registerListener() : window.addEventListener('wixDevelopersAnalyticsReady', registerListener);
}

export function registerVariantChangeEvent() {
  document.addEventListener('click', (evt) => {
    let pageType = window.OnVoardData['page_type'];
    if (window.OnVoardData['page_type'] !== 'product') return;

    let choices = {};
    setTimeout(() => {
      let initialChoices = window.OnVoardData['selected_product_choices'];
      let nodeList = document.querySelectorAll("[data-hook='product-options-inputs'] > .cell");
      nodeList.forEach((el) => {
        let isDropdown = el.querySelector("[data-hook='options-dropdown']") ? true : false;
        let isColorPicker = el.querySelector("[data-hook='color-picker-item']") ? true : false;

        if (!isDropdown && !isColorPicker) return;
        if (isDropdown) {
          let titleEl = el.querySelector("[data-hook='options-dropdown-title']");
          if (!titleEl) return;
          let key = titleEl.innerText;

          let selectedEl = el.querySelector("[data-hook='dropdown-base-text']");
          if (!selectedEl) return;
          let value = selectedEl.innerText;
          choices[key] = value;
        }

        if (isColorPicker) {
          let titleEl = el.querySelector("[data-hook='product-colors-title']");
          if (!titleEl) return;
          let title = titleEl.innerText.trim();
          let titleGroup = title.split(":");

          let key = titleGroup.slice(0)[0];
          if (!key) return;
          key = key.trim();

          let value = titleGroup.slice(1)[0];
          if (!value) return;
          value = value.trim();
          choices[key] = value;
        }
      })

      let changed = !isEqual(initialChoices, choices);
      if (changed) {
        window.OnVoardData['selected_product_choices'] = choices;

        let event = new CustomEvent("ov_wix_variant_change", {detail: choices});
        document.dispatchEvent(event);
      }
    }, 100);
  });

  // on variant change, re-attach scripts since wix may dynamically inject elements
  document.addEventListener('ov_wix_variant_change', (evt) => {
    let addEl = document.querySelector("[data-hook='product-page'] [data-hook='add-to-cart']");
    if (addEl) {
      let referenceNode = addEl.parentElement;
      let parentNode = referenceNode.parentElement;

      let nodeList = parentNode.querySelectorAll(".ov-app");
      nodeList.forEach((el) => {
        parentNode.appendChild(el);
      })
    }
  });
}


export function provision(loadScriptsCallback) {
  loadDynamicModel();
  initPageType();
  initRoutes();
  registerWixListener(loadScriptsCallback);
  registerVariantChangeEvent();
  fetchMemberData();
  cartReload();
}
